
import { CreateCourseContainer } from 'modules/CreateCourse';
import React from 'react'

type Props = {}

const CreateCourse = (props: Props) => {
    return (
        <CreateCourseContainer />
    )
}

export default CreateCourse;